import {Resource} from '@lib/store';

export const sanitizeString = (rawString: string): string => {
  return rawString.trim().toLowerCase();
};

export const resourceMatchesQuery = (resource: Resource, query: string): boolean => {
  const sanitizedQuery = sanitizeString(query);
  return (
    sanitizeString(resource.name).includes(sanitizedQuery) ||
    resource.searchTags.some((tag) => sanitizeString(tag).includes(sanitizedQuery))
  );
};
